import { FileInfo } from '@applyboard/crystal-ui'
import { FileUploadFieldValue } from '../components/Application/ApplicationForms/FileUploadField'
import { has } from 'lodash'
import { nanoid } from 'nanoid'
import { DocumentType } from '@applyboard/school-applications-types-lib'

function isTransformedValue(value: FileUploadFieldValue | FileInfo): boolean {
  return has(value, 'hash') && has(value, 'sectionReference') && has(value, 'type')
}

type Options = {
  type: DocumentType
  sectionReference: string
  additionalFields?: Partial<FileUploadFieldValue>
}

export function transformFileInfoToUploadFileData(
  value: FileUploadFieldValue | FileInfo,
  { type, sectionReference, additionalFields }: Options,
) {
  if (isTransformedValue(value)) return value as FileUploadFieldValue

  const { file } = value
  const id = nanoid()
  const fileUploadData = {
    contentType: file.type,
    file: file,
    fileName: file.name,
    fileSize: file.size,
    hash: nanoid(),
    type,
    sectionReference,
    ...(additionalFields || {}),
  }

  return {
    ...fileUploadData,
    id: id,
  }
}
